import React from "react";
import SpaOutlinedIcon from "@mui/icons-material/SpaOutlined";
import ContentCutOutlinedIcon from "@mui/icons-material/ContentCutOutlined";

export const traceDateKey = (value) => new Intl.DateTimeFormat("sv-SE", {
  timeZone: "Europe/Stockholm", year: "numeric", month: "2-digit", day: "2-digit",
}).format(new Date(value));

export function formatTraceDate(value, language) {
  if (!value) return language === 0 ? "Ej registrerat" : "Not recorded";
  return new Intl.DateTimeFormat(language === 0 ? "sv-SE" : "en-GB", {
    timeZone: "Europe/Stockholm", day: "numeric", month: "long", year: "numeric",
  }).format(new Date(value));
}

export const traceBatchLabel = (value) => traceDateKey(value).slice(2).replace(/-/g, "");

export default function FarmProductTraceTimeline({ batches, language }) {
  const sv = language === 0;
  const unknown = sv ? "Datum saknas" : "Date unavailable";
  const durations = batches.map((batch) => batch.plantDate ? Math.round((batch.harvestDate - batch.plantDate) / 86400000) : null);
  const duration = durations.every((value) => value === durations[0]) ? durations[0] : null;
  const steps = [
    { title: sv ? "Ditt mikrogrönt såddes" : "Your microgreens were sown", dateField: "plantDate", personField: "plantedBy", Icon: SpaOutlinedIcon },
    { title: sv ? "Skördat för dig" : "Harvested for you", dateField: "harvestDate", personField: "harvestedBy", Icon: ContentCutOutlinedIcon },
  ];
  return <article className="BatchTraceDetail" aria-labelledby="batch-trace-detail-title">
    <div className="BatchTraceDetailHeading">
      <div><p className="BatchTraceEyebrow">{sv ? "DIN BATCH" : "YOUR BATCH"}</p>
        <h3 id="batch-trace-detail-title">{traceBatchLabel(batches[0].harvestDate)}</h3></div>
      <span className="BatchTraceBadge">{sv ? "Skördad" : "Harvested"}</span>
    </div>
    <ol className="BatchTraceJourney">
      {steps.map(({ title, dateField, personField, Icon }) => {
        const events = [...new Map(batches.map((batch) => {
          const date = batch[dateField];
          const person = batch[personField];
          return [`${date ? traceDateKey(date) : ""}:${person || ""}`, { date, person }];
        })).values()].sort((a, b) => (a.date || 0) - (b.date || 0));
        return <li key={dateField}>
          <span className="BatchTraceStepIcon"><Icon aria-hidden="true" /></span>
          <div><h4>{title}</h4>{events.map(({ date, person }, index) => <div className="BatchTraceEvent" key={index}>
            <p>{date ? <time dateTime={traceDateKey(date)}>{formatTraceDate(date, language)}</time> : unknown}</p>
            <span className="BatchTracePerson">{person ? `${sv ? "Av" : "By"} ${person}` : (sv ? "Uppgift om odlare saknas" : "Grower details unavailable")}</span>
          </div>)}</div>
        </li>;
      })}
    </ol>
    {duration !== null && <p className="BatchTraceGrowingTime">{sv ? "Från sådd till din skörd" : "From sowing to your harvest"}<strong>{duration} {sv ? "dagar" : "days"}</strong></p>}
  </article>;
}
